import {
    CLEAR_MULTI_BET_RACER_SELECTION,
    SELECT_RACING_BET_TYPE,
    TOGGLE_MULTI_BET_RACER_SELECTION,
    TOGGLE_RACE_CARD_SORT_FIELD_SELECTION
} from '../constants/actionTypes';
import {FORECAST, TO_WIN, TRICAST} from '../constants/identifiers';
import {SORT_BY_NUMBER, SORT_BY_ODD} from '../constants/sortingTypes';
import defaultStoreValues from '../../../../../constants/defaultStoreValues';

export default (state, action) => {
    let newSelectedEventMultiBetList = state.selectedEventMultiBetList.slice();
    switch (action.type) {
        case SELECT_RACING_BET_TYPE:
            if (state.selectedRacingBetType === TRICAST && action.betType === FORECAST) {
                newSelectedEventMultiBetList[2] = undefined;
            }
            if (state.selectedRacingBetType !== TO_WIN && action.betType === TO_WIN) {
                newSelectedEventMultiBetList = defaultStoreValues.selectedEventMultiBetList.slice();
            }

            return {
                ...state,
                selectedRacingBetType: action.betType,
                selectedEventMultiBetList: newSelectedEventMultiBetList
            };
        case TOGGLE_MULTI_BET_RACER_SELECTION:
            let racer = action.racer;
            let position = action.position; //last position is any
            if (position < newSelectedEventMultiBetList.length - 1) {
                if (newSelectedEventMultiBetList[position] && newSelectedEventMultiBetList[position].num === racer.num) {
                    newSelectedEventMultiBetList[position] = undefined;
                } else {
                    newSelectedEventMultiBetList[position] = racer;
                }
            } else {
                let racerInListOfAny = newSelectedEventMultiBetList[position].find(r => racer.num === r.num);

                let indexOfRacerInListOfAny;
                if (racerInListOfAny) {
                    indexOfRacerInListOfAny = newSelectedEventMultiBetList[position].indexOf(racerInListOfAny);
                }

                if (racerInListOfAny && indexOfRacerInListOfAny > -1) {
                    newSelectedEventMultiBetList[position].splice(indexOfRacerInListOfAny, 1);
                } else {
                    //clean list of explicit positions if an any has been placed
                    for (let i = 0; i < newSelectedEventMultiBetList.length - 1; i++) {
                        if (newSelectedEventMultiBetList[i] !== undefined) {
                            newSelectedEventMultiBetList[i] = undefined;
                        }
                    }
                    let auxAnySelection = newSelectedEventMultiBetList[position].slice();
                    auxAnySelection.push(racer);
                    newSelectedEventMultiBetList[position] = auxAnySelection;
                }
            }

            return {
                ...state,
                selectedEventMultiBetList: newSelectedEventMultiBetList
            };
        case CLEAR_MULTI_BET_RACER_SELECTION:
            newSelectedEventMultiBetList = defaultStoreValues.selectedEventMultiBetList.slice();
            return {
                ...state,
                selectedEventMultiBetList: newSelectedEventMultiBetList
            };
        case TOGGLE_RACE_CARD_SORT_FIELD_SELECTION:
            let newSelectedRaceCardSortField;
            newSelectedRaceCardSortField = state.selectedRaceCardSortField === SORT_BY_ODD
                ? SORT_BY_NUMBER
                : SORT_BY_ODD;
            return {
                ...state,
                selectedRaceCardSortField: newSelectedRaceCardSortField
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/reducers/raceCardReducer.js